import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "customer-reviews-details-group" }

import CustomerReviewsBar from '@lmt-rpb/CustomerReviewsBar/CustomerReviewsBar.vue';
import { type PropType } from 'vue';
import { useResizeCollapse } from '../../composables/resizeCollapse';
import BaseIcon from '@lmt-rpb/BaseIcon/BaseIcon.vue';
import { numberFormat } from '@/js/utils/numberUtils';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerReviewsDetailsGroup',
  props: {
	details: {
		type: Object as PropType<Record<string, number>>,
		required: true,
		validator(value: Record<string, number>) {
			return !!Object.keys(value).length;
		}
	},
	maxValue: {
		type: Number,
		required: false,
		default: 6,
	},
	isAlwaysOpen: {
		type: Boolean,
		required: true,
	}
},
  setup(__props) {

const props = __props;

const { isOpen, toggleCollapse } = useResizeCollapse();

const calculateValue = (value: number): string => {
	return numberFormat(Math.max(0, Math.min(value, props.maxValue)));
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["customer-reviews-details-group__wrap", {'open': _unref(isOpen) || __props.isAlwaysOpen}])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.details, (value, key, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index + key,
          class: "customer-reviews-details-group__item"
        }, [
          _createVNode(CustomerReviewsBar, {
            value: value,
            title: key,
            rating: calculateValue(value)
          }, null, 8 /* PROPS */, ["value", "title", "rating"])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 2 /* CLASS */),
    (!__props.isAlwaysOpen)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "customer-reviews-details-group__text-toggle",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleCollapse)()))
        }, [
          _createTextVNode(_toDisplayString(_unref(isOpen) ? 'Weniger' : 'Mehr') + " anzeigen ", 1 /* TEXT */),
          _createVNode(BaseIcon, {
            name: "chevron",
            width: "24",
            height: "24",
            class: _normalizeClass(["customer-reviews-details-group__arrow", {'open': _unref(isOpen)}])
          }, null, 8 /* PROPS */, ["class"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})